import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "annex-alarm-item-row" }
const _hoisted_2 = { class: "annex-alarm-item-row__acknowledge" }
const _hoisted_3 = { class: "annex-alarm-item-row__info" }
const _hoisted_4 = { class: "annex-alarm-item-row__name heading-m" }
const _hoisted_5 = { class: "annex-alarm-item-row__date" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "annex-alarm-item-row__cameras" }
const _hoisted_8 = { class: "annex-alarm-item-row__add" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 1")
const _hoisted_11 = { class: "annex-alarm-item-row__features" }
const _hoisted_12 = { class: "annex-alarm-item-row__confidence" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnnexAlarmAcknowledge = _resolveComponent("AnnexAlarmAcknowledge")!
  const _component_ItemId = _resolveComponent("ItemId")!
  const _component_NIcon = _resolveComponent("NIcon")!
  const _component_AnnexAlarmAcknowledgeInfo = _resolveComponent("AnnexAlarmAcknowledgeInfo")!
  const _component_AnnexAlarmFeatures = _resolveComponent("AnnexAlarmFeatures")!
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_Confidence = _resolveComponent("Confidence")!
  const _component_CardItemRow = _resolveComponent("CardItemRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AnnexAlarmAcknowledge, {
        orientation: "vertical",
        status: _ctx.adaptedItem.acknowledge,
        onAction: _ctx.actionHandler
      }, null, 8, ["status", "onAction"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["annex-alarm-item-row__content", _ctx.classes])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ItemId, {
            class: "annex-alarm-item-row__id",
            id: _ctx.item.id
          }, null, 8, ["id"]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.declaredDateFormated), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_NIcon, { name: "camera" }),
          (_ctx.adaptedItem.cameraGroup?.name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.adaptedItem.cameraGroup?.name) + ", ", 1)
              ], 64))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.adaptedItem.camera?.name || _ctx.item.stream), 1)
        ]),
        _createVNode(_component_AnnexAlarmAcknowledgeInfo, { item: _ctx.item }, null, 8, ["item"]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.item.comment)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createVNode(_component_NIcon, { name: "message" }),
                _hoisted_10
              ]))
            : (_ctx.adaptedItem.acknowledge !== 'none')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.actionHandler('addCommentAndComplete')), ["stop"]))
                }, [
                  _createVNode(_component_NIcon, {
                    name: "add",
                    width: "15",
                    height: "15"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('annex_alarms.add_comment_and_complete')), 1)
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_AnnexAlarmFeatures, {
          features: _ctx.adaptedItem.features
        }, null, 8, ["features"])
      ]),
      _createElementVNode("div", {
        class: "annex-alarm-item-row__thumbnail",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_component_NThumbnail, {
          size: "extra-large",
          "model-value": _ctx.adaptedItem.thumbnail,
          actions: _ctx.thumbnailActions,
          onAction: _cache[1] || (_cache[1] = (v) => _ctx.thumbnailActionHandler(v)),
          "not-found-image-label": _ctx.$t('annex_alarms.not_found')
        }, null, 8, ["model-value", "actions", "not-found-image-label"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.matchedCardHelper.card)
        ? (_openBlock(), _createBlock(_component_Confidence, {
            key: 0,
            value: _ctx.confidence,
            direction: "vertical"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "annex-alarm-item-row__card",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.matchedCardHelper.showCard()), ["stop"]))
    }, [
      (_ctx.matchedCardHelper.card)
        ? (_openBlock(), _createBlock(_component_CardItemRow, {
            key: 0,
            type: _ctx.matchedCardHelper.objectType === 'cars' ? 'cars' : 'humans',
            objectType: _ctx.matchedCardHelper.objectType,
            item: _ctx.matchedCardHelper.card,
            selected: _ctx.matchedCardHelper.isSelected,
            opened: _ctx.matchedCardHelper.isOpened,
            showDate: false,
            closeable: false,
            thumbnailSize: "extra-large"
          }, null, 8, ["type", "objectType", "item", "selected", "opened"]))
        : _createCommentVNode("", true)
    ])
  ]))
}